import {
	type CalendarConnectorType,
	fetchEnabledConnectorTypes,
} from '@atlassian/home-calendar-widget/fetch-connectors';
import type { ThirdPartyConnectorsResult } from '@atlassian/home-calendar-widget/with-preloaded-connectors';

import { createResource } from '@townsquare/router/resources/createResource';
import type { RouteResource } from '@townsquare/router/resources/types';
import type { ResourceContext } from '@townsquare/router/types';
import { useResource } from '@townsquare/router/useResource';

export const calendarConnectorsResource: RouteResource<CalendarConnectorType[]> = createResource<
	CalendarConnectorType[]
>({
	type: 'CALENDAR-CONNECTORS',
	getKey: (_, resourceContext) => {
		const { collabContext } = resourceContext as ResourceContext;

		const cloudId = collabContext?.cloudId;

		return `CALENDAR-CONNECTORS-${cloudId}`;
	},
	getData: async (_, resourceContext) => {
		const { collabContext } = resourceContext as ResourceContext;

		const cloudId = collabContext?.cloudId;

		if (!cloudId) {
			return [];
		}

		return fetchEnabledConnectorTypes(cloudId);
	},
});

export type CalendarConnectorsResult = ThirdPartyConnectorsResult & { error?: Error };

export const useCalendarConnectors = (): CalendarConnectorsResult => {
	const { loading, data, error } = useResource(calendarConnectorsResource);

	if (error) {
		return {
			enabledTypes: [],
			loading: false,
			hasError: true,
			error: error instanceof Error ? error : new Error(String(error)),
		};
	} else if (loading || !data) {
		return {
			enabledTypes: [],
			loading: true,
			hasError: false,
		};
	}

	return {
		enabledTypes: data,
		loading: false,
		hasError: false,
	};
};
